import { render } from "./LoginNav.vue?vue&type=template&id=e2c3a6ae&scoped=true"
import script from "./LoginNav.vue?vue&type=script&lang=js"
export * from "./LoginNav.vue?vue&type=script&lang=js"

import "./LoginNav.vue?vue&type=style&index=0&id=e2c3a6ae&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2c3a6ae"]])

export default __exports__